
export default function Hero() {
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2f46fcdbd3ff21e5cacf660db56f5524.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-8 lg:px-16 text-center">
        <div className="mb-8">
          <div className="w-1 h-20 bg-teal-500 mx-auto mb-8"></div>
        </div>
        <h2 className="text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Modern Applications<br />for iOS Platform
        </h2>
        <p className="text-2xl text-gray-200 font-light max-w-3xl mx-auto">
          Enhancing user experience and mobile security
        </p>
      </div>
    </div>
  );
}
